// import Button from '@material-ui/core/Button';
// import Error from 'Components/Error';
// import FormControl from '@material-ui/core/FormControl';
// import Input from '@material-ui/core/Input';
// import InputLabel from '@material-ui/core/InputLabel';
// import Loader from 'Components/Loader';
// import React from 'react';
// import Success from 'Components/Success';
// import { Drawer } from '@material-ui/core';
// import { API_ROOT } from '../../../../api/Routes';

// import API from '../../api';
// import ProfileMachine from './stateMachine';
// import Logo from './components/Logo';
// import CloseBtn from './components/CloseBtn';
// import FieldError from 'FieldError';
// import { AccountCircle } from '@material-ui/icons';

// class EditCompanyInfo extends React.Component {
//   imgUploadInput = React.createRef();

//   state = {
//     profile: null,
//     error: null,
//     viewState: ProfileMachine.initialState.value,
//     logoPreview: null,
//     avatarWillBeDeleted: false,
//   };

//   componentDidMount() {
//     this.getUserProfile();
//   }

//   getUserProfile = () => {
//     debugger;
//     API.getUserProfile()
//       .then(res => {
//         this.setState({
//           profile: res.data,
//           viewState: ProfileMachine.transition(
//             ProfileMachine.initialState.value,
//             'PROFILE'
//           ).value,
//         });
//       })
//       .catch(err => {
//         this.setState({
//           error: err,
//           viewState: ProfileMachine.transition(
//             ProfileMachine.initialState.value,
//             'ERROR'
//           ).value,
//         });
//       });
//   };

//   updateField = (isRegion = false) => e => {
//     e.persist();
//     const input = isRegion ? e.target.name : e.target.getAttribute('name');
//     if (input === 'region') {
//       this.setState(state => ({
//         ...state,
//         profile: {
//           ...state.profile,
//           officeAddress: '',
//         },
//       }));
//     }
//     if (input === 'profileImage' && e.target.files && e.target.files[0]) {
//       if (e.target.files[0].size > 5242880) {
//         e.target.value = '';

//         return this.setState(state => {
//           return {
//             ...state,
//             viewState: ProfileMachine.transition(
//               state.viewState,
//               'PHOTO_SIZE_ERROR'
//             ).value,
//             avatarWillBeDeleted: false,
//           };
//         });
//       }
//       const reader = new FileReader();
//       reader.onload = readEvent => {
//         this.setState(state => {
//           return {
//             ...state,
//             logoPreview: readEvent.target.result,
//             profile: {
//               ...state.profile,
//               [input]: e.target.files[0],
//             },
//             avatarWillBeDeleted: false,
//           };
//         });
//       };
//       reader.readAsDataURL(e.target.files[0]);
//     } else {
//       this.setState(state => ({
//         ...state,
//         profile: {
//           ...state.profile,
//           companyInfo: {
//             ...state.profile.companyInfo,
//             [input]: e.target.value,
//           },
//         },
//       }));
//     }
//   };

//   onUserProfileUpdate = () => {
//     this.setState(
//       state => ({
//         viewState: ProfileMachine.transition(state.viewState, 'EDIT').value,
//       }),
//       () => {
//         let form = new FormData();
//         for (let prop in this.state.profile) {
//           if (this.state.profile[prop] === null) {
//             continue;
//           }
//           form.append(prop, this.state.profile[prop]);
//         }

//         API.updateUserProfile(form)
//           .then(res => {
//             if (this.state.avatarWillBeDeleted) {
//               this.removeImage();
//             }
//             this.setState(
//               state => ({
//                 viewState: ProfileMachine.transition(state.viewState, 'UPDATED')
//                   .value,
//               }),
//               this.props.getCurentUser
//             );
//           })
//           .catch(err => {
//             this.setState(state => ({
//               error: err,
//               viewState: ProfileMachine.transition(state.viewState, 'ERROR')
//                 .value,
//               avatarWillBeDeleted: false,
//             }));
//           });
//       }
//     );
//   };

//   onErrorCancel = () => {
//     this.setState(state => ({
//       error: null,
//       viewState: ProfileMachine.transition(state.viewState, 'CANCEL').value,
//     }));
//   };

//   onModalClose = () => {
//     this.setState(state => ({
//       viewState: ProfileMachine.transition(state.viewState, 'CONFIRM').value,
//     }));
//   };

//   onDrawerClose = () => {
//     this.props.onClose();
//     this.getUserProfile();
//     this.setState({
//       logoPreview: null,
//       avatarWillBeDeleted: false,
//     });
//   };

//   removeImage = () => {
//     if (this.state.profile.imageId) {
//       API.deleteAsset(this.state.profile.imageId)
//         .then(res => {
//           this.setState(
//             state => ({
//               viewState: ProfileMachine.transition(state.viewState, 'UPDATED')
//                 .value,
//               profile: {
//                 ...this.state.profile,
//                 imageId: null,
//               },
//               avatarWillBeDeleted: false,
//             }),
//             this.props.getCurentUser
//           );
//         })
//         .catch(err => {
//           this.setState(state => ({
//             error: err,
//             viewState: ProfileMachine.transition(state.viewState, 'ERROR')
//               .value,
//             avatarWillBeDeleted: false,
//           }));
//         });
//     }
//   };

//   clearImage = () => {
//     this.imgUploadInput.current.value = '';

//     this.setState({
//       avatarWillBeDeleted: true,
//       logoPreview: null,
//       profile: {
//         ...this.state.profile,
//         profileImage: null,
//       },
//     });
//   };

//   isSomeFieldEmpty = () => {
//     if (
//       !this.state.profile.firstName ||
//       !this.state.profile.lastName ||
//       !this.state.profile.officeAddress ||
//       !this.state.profile.region ||
//       !this.state.profile.mobilePhone
//     ) {
//       return true;
//     }
//     return false;
//   };

//   renderImage() {
//     if (
//       (!this.state.profile.imageId && !this.state.logoPreview) ||
//       this.state.avatarWillBeDeleted
//     ) {
//       return <AccountCircle className="editProfileAvatar" />;
//     }

//     let image;
//     if (this.state.logoPreview) {
//       image = this.state.logoPreview;
//     } else if (this.state.profile.imageId) {
//       image = `${API_ROOT}/asset/${this.state.profile.imageId}`;
//     }

//     return (
//       <Logo image={image} trigerRemoveImage={this.clearImage} showDeleteBtn />
//     );
//   }

//   render() {
//     if (!this.state.profile) {
//       return <Loader isLoading />;
//     }
//     const {
//       name,
//       address,
//       phone,
//       website,
//       registeredCompanyNumber,
//     } = this.state.profile.companyInfo;

//     return (
//       <Drawer
//         anchor="right"
//         open={this.props.editCompanyInfo}
//         onClose={this.onDrawerClose}
//         classes={{
//           paper: 'bc-gray u-pad-r-60 u-pad-l-60 mw540 t-align-c scroll-auto',
//         }}
//       >
//         <Success
//           open={this.state.viewState === 'updated'}
//           message="Company info updated"
//           handleClose={this.onModalClose}
//         />
//         {this.state.viewState === 'loading' ? <Loader isLoading /> : null}
//         {this.state.viewState === 'error' ? (
//           <Error onCancel={this.onErrorCancel} errors={this.state.error} />
//         ) : null}

//         {this.state.viewState === 'photo_size_error' ? (
//           <Error
//             onCancel={this.onErrorCancel}
//             errors={'Image size cannot be greater then 5 MB'}
//           />
//         ) : null}
//         <div>
//           <CloseBtn onClick={this.onDrawerClose} />
//           <h2 className="t-secondary-30 u-mrg-bot-30 u-mrg-top-60">
//             Edit company info
//           </h2>
//           <div className="editProfileWrapper">
//             {this.renderImage()}
//             <input
//               name="companyImage"
//               type="file"
//               onChange={this.updateField()}
//               ref={this.imgUploadInput}
//             />
//           </div>

//           <b className="c-s_gray t-primary-16 u-mrg-top-20 element-block">
//             Add/change company logo
//           </b>
//           <div className="flexblock u-mrg-top-60">
//             <Grid container spacing={16}>
//               <Grid item xs={12}>
//                 <FormControl fullWidth>
//                   <InputLabel
//                     htmlFor="Company name"
//                     classes={{
//                       root: 'label--c-gray',
//                     }}
//                   >
//                     Company name
//                   </InputLabel>
//                   <Input
//                     classes={{
//                       underline: 'underline--c-light',
//                     }}
//                     name="name"
//                     type="text"
//                     label="Company name"
//                     value={name}
//                     onChange={this.updateField()}
//                   />
//                   {!this.state.profile.companyInfo.name && (
//                     <FieldError>This field can not be empty!</FieldError>
//                   )}
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12}>
//                 <FormControl fullWidth>
//                   <InputLabel
//                     htmlFor="Company address"
//                     classes={{
//                       root: 'label--c-gray',
//                     }}
//                   >
//                     Company address
//                   </InputLabel>
//                   <Input
//                     classes={{
//                       underline: 'underline--c-light',
//                     }}
//                     name="address"
//                     type="text"
//                     label="Company address"
//                     value={address}
//                     onChange={this.updateField()}
//                   />
//                   {!this.state.profile.companyInfo.address && (
//                     <FieldError>This field can not be empty!</FieldError>
//                   )}
//                 </FormControl>
//               </Grid>
//               <Grid item xs={6}>
//                 <FormControl fullWidth>
//                   <InputLabel
//                     htmlFor="Phone"
//                     classes={{
//                       root: 'label--c-gray',
//                     }}
//                   >
//                     Phone
//                   </InputLabel>
//                   <Input
//                     classes={{
//                       underline: 'underline--c-light',
//                     }}
//                     name="phone"
//                     type="text"
//                     label="Phone"
//                     value={phone}
//                     onChange={this.updateField()}
//                   />
//                   {!this.state.profile.companyInfo.phone && (
//                     <FieldError>This field can not be empty!</FieldError>
//                   )}
//                 </FormControl>
//               </Grid>
//               <Grid item xs={6}>
//                 <FormControl fullWidth>
//                   <InputLabel
//                     htmlFor="Website"
//                     classes={{
//                       root: 'label--c-gray',
//                     }}
//                   >
//                     Website
//                   </InputLabel>
//                   <Input
//                     classes={{
//                       underline: 'underline--c-light',
//                     }}
//                     name="website"
//                     type="text"
//                     label="Website"
//                     value={website}
//                     onChange={this.updateField()}
//                   />
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12}>
//                 <FormControl fullWidth>
//                   <InputLabel
//                     htmlFor="Registered company number"
//                     classes={{
//                       root: 'label--c-gray',
//                     }}
//                   >
//                     Registered company number
//                   </InputLabel>
//                   <Input
//                     classes={{
//                       underline: 'underline--c-light',
//                     }}
//                     name="registeredCompanyNumber"
//                     type="text"
//                     label="Registered company number"
//                     value={registeredCompanyNumber}
//                     onChange={this.updateField()}
//                   />
//                 </FormControl>
//               </Grid>
//             </Grid>
//           </div>
//         </div>
//         <div>
//           <Button
//             fullWidth
//             variant="contained"
//             color="primary"
//             className="t-weight-b pointer u-mrg-right-0 u-mrg-top-60 u-mrg-bot-60"
//             onClick={this.onUserProfileUpdate}
//             disabled={
//               this.state.viewState === 'loading' || this.isSomeFieldEmpty()
//             }
//           >
//             SAVE
//           </Button>
//         </div>
//       </Drawer>
//     );
//   }
// }

// export default EditCompanyInfo;
import Button from '@material-ui/core/Button';
import Error from 'Components/Error';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Loader from 'Components/Loader';
import React from 'react';
import Success from 'Components/Success';
import { Drawer } from '@material-ui/core';
import { API_ROOT } from '../../../../api/Routes';

import API from '../../api';
import ProfileMachine from './stateMachine';
import Logo from './components/Logo';
import CloseBtn from './components/CloseBtn';
import FieldError from 'FieldError';
import { AccountCircle } from '@material-ui/icons';

class EditProfileDrawer extends React.Component {
  imgUploadInput = React.createRef();

  state = {
    profile: null,
    error: null,
    viewState: ProfileMachine.initialState.value,
    logoPreview: null,
    avatarWillBeDeleted: false,
  };

  componentDidMount() {
    this.getUserProfile();
  }

  getUserProfile = () => {
    API.getUserProfile()
      .then(res => {
        this.setState({
          profile: res.data,
          viewState: ProfileMachine.transition(
            ProfileMachine.initialState.value,
            'PROFILE'
          ).value,
        });
      })
      .catch(err => {
        this.setState({
          error: err,
          viewState: ProfileMachine.transition(
            ProfileMachine.initialState.value,
            'ERROR'
          ).value,
        });
      });
  };

  updateField = (isRegion = false) => e => {
    e.persist();
    const input = isRegion ? e.target.name : e.target.getAttribute('name');
    if (input === 'region') {
      this.setState(state => ({
        ...state,
        profile: {
          ...state.profile,
          officeAddress: '',
        },
      }));
    }
    if (input === 'profileImage' && e.target.files && e.target.files[0]) {
      if (e.target.files[0].size > 5242880) {
        e.target.value = '';

        return this.setState(state => {
          return {
            ...state,
            viewState: 'PHOTO_SIZE_ERROR',
            avatarWillBeDeleted: false,
          };
        });
      }
      const reader = new FileReader();
      reader.onload = readEvent => {
        this.setState(state => {
          return {
            ...state,
            logoPreview: readEvent.target.result,
            profile: {
              ...state.profile,
              companyInfo: {
                ...state.profile.companyInfo,
                companyLogo: e.target.files[0],
              },
            },
            avatarWillBeDeleted: false,
          };
        });
      };
      reader.readAsDataURL(e.target.files[0]);
    } else {
      this.setState(state => ({
        ...state,
        profile: {
          ...state.profile,
          companyInfo: {
            ...state.profile.companyInfo,
            [input]: e.target.value,
          },
        },
      }));
    }
  };

  mapperFunction = ({
    name,
    address,
    phone,
    website,
    registeredCompanyNumber,
    companyCountry,
    companyCity,
    // companyLogo,
  }) => {
    let companyName = name ? name : null;
    let companyAddress = address ? address : null;
    return {
      companyName,
      companyAddress,
      phone: phone ? phone : null,
      website: website ? website : null,
      registeredCompanyNumber: registeredCompanyNumber
        ? registeredCompanyNumber
        : null,
      companyCountry: companyCountry ? companyCountry : null,
      companyCity: companyCity ? companyCity : null,
      // logo: companyLogo ? companyLogo : null,
    };
  };

  onUserProfileUpdate = () => {
    let temp = this.mapperFunction(this.state.profile.companyInfo);
    let form = new FormData();
    for (let prop in temp) {
      if (temp[prop] === null) {
        continue;
      }
      form.append(prop, temp[prop]);
    }
    API.updateNonArupCompanyInfo(form)
      .then(res => {
        if (this.state.avatarWillBeDeleted) {
          this.removeImage();
        }
        this.setState(
          state => ({
            viewState: 'updated',
          }),
          this.props.getCurentUser
        );
      })
      .catch(err => {
        this.setState(state => ({
          error: err,
          viewState: 'error',
          avatarWillBeDeleted: false,
        }));
      });
  };

  onErrorCancel = () => {
    this.setState(state => ({
      error: null,
      viewState: ProfileMachine.transition(state.viewState, 'CANCEL').value,
    }));
  };

  onModalClose = () => {
    this.setState(state => ({
      viewState: ProfileMachine.transition(state.viewState, 'CONFIRM').value,
    }));
  };

  onDrawerClose = () => {
    this.props.onClose();
    this.getUserProfile();
    this.setState({
      logoPreview: null,
      avatarWillBeDeleted: false,
    });
  };

  removeImage = () => {
    if (this.state.profile.imageId) {
      API.deleteAsset(this.state.profile.companyInfo.companyLogo)
        .then(res => {
          this.setState(
            state => ({
              viewState: ProfileMachine.transition(state.viewState, 'UPDATED')
                .value,
              profile: {
                ...this.state.profile,
                companyInfo: {
                  ...this.state.profile.companyInfo,
                  companyLogo: null,
                },
              },
              avatarWillBeDeleted: false,
            }),
            this.props.getCurentUser
          );
        })
        .catch(err => {
          this.setState(state => ({
            error: err,
            viewState: ProfileMachine.transition(state.viewState, 'ERROR')
              .value,
            avatarWillBeDeleted: false,
          }));
        });
    }
  };

  clearImage = () => {
    this.imgUploadInput.current.value = '';

    this.setState({
      avatarWillBeDeleted: true,
      logoPreview: null,
      profile: {
        ...this.state.profile,
        companyInfo: {
          ...this.state.profile.companyInfo,
          companyLogo: null,
        },
      },
    });
  };

  isSomeFieldEmpty = () => {
    if (
      !this.state.profile.companyInfo.name ||
      !this.state.profile.companyInfo.address ||
      !this.state.profile.companyInfo.phone ||
      !this.state.profile.companyInfo.website ||
      !this.state.profile.companyInfo.registeredCompanyNumber
    ) {
      return true;
    }
    return false;
  };

  renderImage() {
    if (
      (!this.state.profile.companyInfo.companyLogo &&
        !this.state.logoPreview) ||
      this.state.avatarWillBeDeleted
    ) {
      return <AccountCircle className="editProfileAvatar" />;
    }

    let image;
    if (this.state.logoPreview) {
      image = this.state.logoPreview;
    } else if (this.state.profile.companyInfo) {
      image = `${API_ROOT}/asset/${this.state.profile.companyInfo.companyLogo}`;
    }

    return (
      <Logo image={image} trigerRemoveImage={this.clearImage} showDeleteBtn />
    );
  }

  render() {
    if (!this.state.profile) {
      return <Loader isLoading />;
    }
    const { companyInfo } = this.state.profile;

    return (
      <Drawer
        anchor="right"
        open={this.props.editCompanyInfo}
        onClose={this.onDrawerClose}
        classes={{
          paper: 'bc-gray u-pad-r-60 u-pad-l-60 mw540 t-align-c scroll-auto',
        }}
      >
        <Success
          open={this.state.viewState === 'updated'}
          message="Profile updated"
          handleClose={this.onModalClose}
        />
        {this.state.viewState === 'loading' ? <Loader isLoading /> : null}
        {this.state.viewState === 'error' ? (
          <Error onCancel={this.onErrorCancel} errors={this.state.error} />
        ) : null}

        {this.state.viewState === 'photo_size_error' ? (
          <Error
            onCancel={this.onErrorCancel}
            errors={'Image size cannot be greater then 5 MB'}
          />
        ) : null}
        <div>
          <CloseBtn onClick={this.onDrawerClose} />
          <h2 className="t-secondary-30 u-mrg-bot-30 u-mrg-top-60">
            Edit company info
          </h2>
          {/* 
          <div className="editProfileWrapper">
            {this.renderImage()}
            <input
              name="profileImage"
              type="file"
              onChange={this.updateField()}
              ref={this.imgUploadInput}
            />
          </div>

          <b className="c-s_gray t-primary-16 u-mrg-top-20 element-block">
            Add/change company logo
          </b> */}
          <div className="flexblock u-mrg-top-60">
            <FormControl fullWidth className="u-mrg-right-10">
              <InputLabel
                htmlFor="Company name"
                classes={{
                  root: 'label--c-gray',
                }}
              >
                Company name
              </InputLabel>
              <Input
                classes={{
                  underline: 'underline--c-light',
                }}
                name="name"
                type="text"
                label="Company name"
                value={companyInfo.name}
                onChange={this.updateField()}
              />
              {!this.state.profile.companyInfo.name && (
                <FieldError>This field can not be empty!</FieldError>
              )}
            </FormControl>
            <FormControl fullWidth className="u-mrg-left-10">
              <InputLabel
                htmlFor="Company address"
                classes={{
                  root: 'label--c-gray',
                }}
              >
                Company address
              </InputLabel>
              <Input
                classes={{
                  underline: 'underline--c-light',
                }}
                name="address"
                type="text"
                label="Company address"
                value={companyInfo.address}
                onChange={this.updateField()}
              />
              {!this.state.profile.companyInfo.address && (
                <FieldError>This field can not be empty!</FieldError>
              )}
            </FormControl>
          </div>
          <div className="flexblock u-mrg-top-30">
            <FormControl fullWidth className="u-mrg-right-10">
              <InputLabel
                htmlFor="Company country"
                classes={{
                  root: 'label--c-gray',
                }}
              >
                Company country
              </InputLabel>
              <Input
                classes={{
                  underline: 'underline--c-light',
                }}
                name="companyCountry"
                type="text"
                label="Company country"
                value={companyInfo.companyCountry}
                onChange={this.updateField()}
              />
              {!this.state.profile.companyInfo.companyCountry && (
                <FieldError>This field can not be empty!</FieldError>
              )}
            </FormControl>
            <FormControl fullWidth>
              <InputLabel
                htmlFor="Company city"
                classes={{
                  root: 'label--c-gray',
                }}
              >
                Company city
              </InputLabel>
              <Input
                classes={{
                  underline: 'underline--c-light',
                }}
                name="companyCity"
                type="text"
                label="Company city"
                value={companyInfo.companyCity}
                onChange={this.updateField()}
              />
            </FormControl>
          </div>
          <div className="flexblock u-mrg-top-30">
            <FormControl fullWidth className="u-mrg-right-10">
              <InputLabel
                htmlFor="Phone"
                classes={{
                  root: 'label--c-gray',
                }}
              >
                Phone
              </InputLabel>
              <Input
                classes={{
                  underline: 'underline--c-light',
                }}
                name="phone"
                type="text"
                label="Phone"
                value={companyInfo.phone}
                onChange={this.updateField()}
              />
              {!this.state.profile.companyInfo.phone && (
                <FieldError>This field can not be empty!</FieldError>
              )}
            </FormControl>
            <FormControl fullWidth>
              <InputLabel
                htmlFor="Website"
                classes={{
                  root: 'label--c-gray',
                }}
              >
                Website
              </InputLabel>
              <Input
                classes={{
                  underline: 'underline--c-light',
                }}
                name="website"
                type="text"
                label="Website"
                value={companyInfo.website}
                onChange={this.updateField()}
              />
            </FormControl>
          </div>
          <FormControl fullWidth className="u-mrg-top-30">
            <InputLabel
              htmlFor="Registered company number"
              classes={{
                root: 'label--c-gray',
              }}
            >
              Registered company number
            </InputLabel>
            <Input
              classes={{
                underline: 'underline--c-light',
              }}
              name="registeredCompanyNumber"
              type="text"
              label="Registered company number"
              value={companyInfo.registeredCompanyNumber}
              onChange={this.updateField()}
            />
          </FormControl>
        </div>
        <div>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className="t-weight-b pointer u-mrg-right-0 u-mrg-top-60 u-mrg-bot-60"
            onClick={this.onUserProfileUpdate}
            disabled={
              this.state.viewState === 'loading' || this.isSomeFieldEmpty()
            }
          >
            SAVE
          </Button>
        </div>
      </Drawer>
    );
  }
}

export default EditProfileDrawer;
